<script setup>
defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: null,
  },
  dt: {
    type: Object,
    default: () => ({
      body: {
        padding: '0px !important',
      },
    }),
  },
})
</script>

<template>
  <Card :dt="dt">
    <template #header>
      <div class="bg-gray-100 dark:bg-gray-800 p-4 rounded-t-md">
        <div class="flex justify-between">
          <h5 class="mb-0 flex items-center gap-2 text-lg font-semibold">
            <slot name="heading"></slot>
          </h5>
          <div class="ml-auto flex items-center gap-2">
            <ProgressSpinner v-if="loading" class="w-4 h-4" />
            <slot name="controls"></slot>
          </div>
        </div>

        <slot name="notices">
          <div v-if="error" class="mt-2">
            <Message severity="error" class="text-center max-w-fit">{{ error }}</Message>
          </div>
        </slot>
      </div>
    </template>
    <template #content>
      <slot v-if="!loading && !error"></slot>
    </template>
  </Card>
</template>

<style scoped>
  @reference '../../../css/tailwind.css';

  :deep(a) {
    @apply text-primary-500 hover:text-primary-600 dark:text-primary-400 dark:hover:text-primary-300;
  }
</style>
